import { createAction } from "@reduxjs/toolkit";

export const setAreeError = createAction<string | null>("aree/setError");
